import React, { useEffect, useState } from "react"
import { Button, Card, CardBody, CardTitle, Col, Container, Form, Row } from "reactstrap"
import PropTypes from "prop-types"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import StickerToolbarButtons from "../../components/Common/sticker-toolbar-buttons"
import ButtonRedirect from "../../components/Common/button-redirect"
import { useLocation, withRouter } from "react-router-dom"
import { connect } from "react-redux"
import usePermission from "helpers/permission/usePermission"
import { getCompanies } from "../../helpers/utils"
import FormSelectCompany from "../../components/Common/form-select-company"
import FormInputText from "../../components/Common/form-input-text"
import FormInputDate from "../../components/Common/form-input-date"
import FormInputSelect from "../../components/Common/form-input-select"
import { withTranslation } from "react-i18next"
import {
  apiBuscarIAPrompt,
  apiBuscarTiposEmpresa,
  apiCadastrarIAPrompt,
  apiEditarIAPrompt,
  apiRemoverIAPrompt
} from "../../helpers/backend_helper"
import { navegarBreadCrumb } from "../../store/navigator/actions"
import { translationForm } from "./utils/translation"
import FormInputSwitch from "../../components/Common/form-input-switch"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import FormInputArea from "../../components/Common/form-input-area"
import swal from "sweetalert"

const CadastrarAiPrompt = props => {
  const [prompt, setPrompt] = useState(null)
  const [id, setId] = useState(null)
  const [empresa, setEmpresa] = useState(null)
  const [tipoEmpresa, setTipoEmpresa] = useState(null)
  const [nome, setNome] = useState("")
  const [instrucoes, setInstrucoes] = useState("")
  const [modelo, setModelo] = useState("")
  const [status, setStatus] = useState("A")
  const [dataAlteracao, setDataAlteracao] = useState(null)
  const [usuarioAlteracao, setUsuarioAlteracao] = useState("")

  const [companies, setCompanies] = useState([])
  const [tiposEmpresa, setTiposEmpresa] = useState([])

  const usePermissionEdit = usePermission("aiPrompt_editar")
  const usePermissionInsert = usePermission("aiPrompt_inserir")
  const usePermissionRemove = usePermission("aiPrompt_excluir")

  const isInforangra = props.user?.usuario_info
  const isAdmin = props.user?.usuario_info && props.user?.usuario_info?.perfil?.administrador

  const location = useLocation()
  const translate = translationForm(props)

  useEffect(() => {
    if (!isInforangra) return

    const idCloud = props.match.params.hasOwnProperty("idCloud") ? props.match.params.idCloud : null

    if (idCloud) {
      carregar(idCloud).then()
      props.navegarBreadCrumb({
        title: translate.breadcrumbTitle,
        link: location.pathname,
        id: idCloud
      })
    } else {
      preencherFormulario(null)

      setId(null)
      setEmpresa(companies[0]?.value)

      props.navegarBreadCrumb({
        title: translate.breadcrumbNew,
        link: location.pathname
      })
    }
  }, [props.match.params])

  useEffect(() => {
    const tmpCompanies = getCompanies(props.user, isAdmin)
    setCompanies(tmpCompanies)
    setEmpresa(isAdmin ? null : tmpCompanies[0].value)

    return () => {
      setCompanies([])
    }
  }, [])

  useEffect(() => {
    if (!isInforangra) return
    const carregarTiposEmpresa = async () => {
      try {
        const response = await apiBuscarTiposEmpresa()
        if (response && Array.isArray(response)) {
          const options = response.map(tipo => ({
            value: tipo.tipo,
            label: tipo.descricao
          }))
          setTiposEmpresa(options)
        }
      } catch (error) {
        console.error(translate.error, error)
      }
    }
    carregarTiposEmpresa().then()
    return () => setTiposEmpresa([])
  }, [])

  const carregar = async idCloud => {
    const prompt = await apiBuscarIAPrompt({ id: idCloud })
    setPrompt(prompt)
    preencherFormulario(prompt || {})
  }

  const preencherFormulario = (prompt) => {
    setId(prompt?.id)
    setEmpresa(prompt?.idEmpresa)
    setTipoEmpresa(prompt?.idTipoEmpresa)
    setNome(prompt?.nome)
    setInstrucoes(prompt?.instrucoes)
    setModelo(prompt?.modelo)
    setStatus(prompt?.status || "A")
    setDataAlteracao(prompt?.altData ? new Date(prompt?.altData) : null)
    setUsuarioAlteracao(`${prompt?.altFunc} - ${prompt?.altFunc_Nome}`)
  }

  const remover = async () => {
    try {
      await apiRemoverIAPrompt({ id })
      props.history.push("/ai-prompts")
      swal({ title: translate.removeSuccess, icon: "success" }).then(
        () => {
          props.history.push("/ai-prompts")
        }
      )

    } catch (error) {
      const backendMsg = error?.response?.data || error?.message

      swal({ title: translate.removeError, icon: "error", text: backendMsg }).then()
    }
  }

  const salvar = async () => {
    if (!tipoEmpresa || !nome || !modelo || !instrucoes) {
        const divs = document.getElementsByName("validate-required")
        for (let i = 0; i < divs.length; i++) {
          divs[i].style.display = "block"
        }
        window.scrollTo(0, 0)
        toastr.error('Há campos obrigatórios não preenchidos!', 'Validação de informações')

      return
    }

    const promptPersistir = prompt ? Object.assign({}, prompt) : {}
    promptPersistir.idEmpresa = empresa
    promptPersistir.idTipoEmpresa = tipoEmpresa
    promptPersistir.nome = nome
    promptPersistir.instrucoes = instrucoes
    promptPersistir.modelo = modelo
    promptPersistir.status = status

    try {
      if (promptPersistir.id) {
        await apiEditarIAPrompt(promptPersistir)
        swal({ title: translate.editSuccess, icon: "success" }).then(
          () => {
            props.history.push("/ai-prompts")
          }
        )
      } else {
        await apiCadastrarIAPrompt(promptPersistir)
        swal({ title: translate.saveSuccess, icon: "success" }).then(
          () => {
            props.history.push("/ai-prompts")
          }
        )
      }
    } catch (error) {
      const backendMsg = error?.response?.data || error?.message
      if (promptPersistir.id) {
        swal({ title: translate.editError, icon: "error", text: backendMsg }).then()
      } else {
        swal({ title: translate.saveError, icon: "error", text: backendMsg }).then()
      }
    }
  }

  if (!isInforangra) return null

  const disabled = !!id ? !usePermissionEdit : !usePermissionInsert

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs
          title={translate.breadcrumbTitle}
          breadcrumbItem={
            id ? translate.breadcrumbEdit : translate.breadcrumbNew
          }
        />
        <StickerToolbarButtons>
          <ButtonRedirect path={"ai-prompts"} history={props.history} />
          <Button
            type="submit"
            color="primary"
            className="waves-effect waves-light me-2"
            disabled={!!id ? !usePermissionEdit : !usePermissionInsert}
            onClick={() => salvar()}>
            {translate.save}
          </Button>
          {id && <>
            <Button
              type="submit"
              color="danger"
              className="waves-effect waves-light me-2"
              disabled={!usePermissionRemove}
              onClick={() => remover()}>
              {translate.remove}
            </Button>
          </>
          }
        </StickerToolbarButtons>
        <Row>
          <Col lg={12}>
            <div className="outer">
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">{translate.cardTitle}</CardTitle>
                  <Form>
                    <div className="outer">
                      <div className="outer">
                        <FormSelectCompany
                          attribute="empresa"
                          description={translate.company}
                          value={empresa}
                          setValue={setEmpresa}
                          options={companies}
                          disabled={disabled}
                        />
                        <FormInputSelect
                          attribute="tipoEmpresa"
                          description={translate.companyType}
                          value={tipoEmpresa}
                          setValue={setTipoEmpresa}
                          options={tiposEmpresa}
                          required
                          disabled={disabled}
                        />
                        <FormInputText
                          attribute="nome"
                          description={translate.name}
                          value={nome}
                          setValue={setNome}
                          maxLength={200}
                          required
                          disabled={disabled}
                        />
                        <FormInputText
                          attribute="modelo"
                          description={translate.model}
                          value={modelo}
                          setValue={setModelo}
                          maxLength={200}
                          required
                          disabled={disabled}
                        />
                        <FormInputArea
                          attribute="instrucoes"
                          description={translate.instructions}
                          value={instrucoes}
                          setValue={setInstrucoes}
                          rows="5"
                          required
                          disabled={disabled}
                        />

                        <FormInputSwitch
                          attribute="status"
                          description={translate.status}
                          value={status}
                          setValue={setStatus}
                          trueValue="A"
                          falseValue="I"
                        />
                      </div>
                    </div>
                  </Form>
                </CardBody>
              </Card>

              {id && (
                <Card>
                  <CardBody>
                    <CardTitle className="mb-4">
                      {translate.cardTitleAlteration}
                    </CardTitle>
                    <Form>
                      <div className="outer">
                        <div className="outer">
                          <FormInputDate
                            attribute="dataAlteracao"
                            description={translate.alterationDate}
                            value={dataAlteracao}
                            disabled={true}
                            dateFormat={"dd/MM/yyyy HH:mm:ss"}
                            withHour={true}
                          />
                          <FormInputText
                            attribute="usuarioAlteracao"
                            description={translate.alterationUser}
                            value={usuarioAlteracao}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

CadastrarAiPrompt.propTypes = {
  user: PropTypes.any,
  history: PropTypes.any,
  match: PropTypes.any,
  navegarBreadCrumb: PropTypes.func
}

const mapStatetoProps = state => {
  const { user } = state.Login
  return { user }
}

export default withTranslation()(
  connect(mapStatetoProps, { navegarBreadCrumb })(withRouter(CadastrarAiPrompt))
)
